import React from 'react'
import { use, api } from 'xadmin'

const useCommWS = props => {
  const onMessageFunc = React.useRef(null)
  const onDataFunc = React.useRef(null)
  const onStatusFunc = React.useRef(null)

  const onMessage = React.useCallback(fn => onMessageFunc.current = fn)
  const onData = React.useCallback(fn => onDataFunc.current = fn)
  const onStatus = React.useCallback(fn => onStatusFunc.current = fn)

  const subscribe = (url, query) => {
    let socket = null
    let connecting = false
    let forceDisconnect = false
    let reConnectCount = 0
    const status = status => onStatusFunc.current && onStatusFunc.current(status)

    const keepLive = () => {
      const emitMessage = () => {
        const readyState = socket && socket.readyState
        if (readyState == 1) {
          socket.send('client send keeplive message!')
          keepLive()
        }
      }
      return setTimeout(emitMessage, 30000)
    }

    const creatSocket = () => {
      socket = new WebSocket(url)
      connecting = true
      status('connecting')

      socket.onopen = () => {
        console.log('WebSocket已链接!')
        connecting = false
        reConnectCount = 0
        status('connected')

        socket.onmessage = msg => {
          const message = JSON.parse(msg.data)
          onMessageFunc.current && onMessageFunc.current(message)
          onDataFunc.current && onDataFunc.current(message.data, socket)
        }

        socket.onclose = v => {
          console.log('WebSocket已关闭')
          status('close', v)
          reconnectSocket()
        }

        // 发送订阅条件
        const subscribeQuery = JSON.stringify({ type: 'query', data: query })
        socket.send(subscribeQuery)

        keepLive()
      }

      socket.onerror = err => {
        console.error('WebSocket连接错误', err)
        status('error', err)
        reconnectSocket()
      }
    }

    const reconnectSocket = () => {
      if (!connecting && !forceDisconnect) {
        let timeout = 3000
        if (reConnectCount > 10 && reConnectCount < 20) timeout = 10000
        if (reConnectCount > 20) timeout = 60000
        reConnectCount++
        console.log(`WebSocket正在尝试第次${reConnectCount}重新链接...!`)
        setTimeout(() => creatSocket(), timeout)
      }
    }

    creatSocket()

    return () => {
      forceDisconnect = true
      socket && socket.close()
    }
  }

  return { subscribe, onData, onMessage, onStatus }
}

const useWS = props => {
  const { subscribe: commSubscribe, onData, onMessage, onStatus } = useCommWS(props)

  const headers = api('Node').getHeaders()
  const token = headers?.Authorization
  const projectID = headers && headers['x-request-project']

  const subscribe = (subType, query) => {
    const protocol = window.location.protocol.indexOf('https') == 0 ? 'wss' : 'ws'
    const project = projectID ? `&x-request-project=${projectID}` : ''
    const url = `${protocol}://${window.location.host}/ws/${subType}?token=${token}${project}`
    return commSubscribe(url, query)
  }

  return { subscribe, onData, onMessage, onStatus }
}

const useWSData = ({ query }) => {
  const { subscribe, onData, onStatus } = useWS()

  React.useEffect(() => {
    return subscribe('data', query)
  }, [query])

  return { onData, onStatus }
}

export default {
  hooks: {
    'ws': useWS,
    'ws.data': useWSData
  }
}
